import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { CreateAccountRequest } from '../../types/interfaces/account';
import { CreateUserRequest } from '../../types/interfaces/user/CreateUserRequest';
import { User } from '../../types/interfaces/user';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account/`;

export const createUser = async (accountId: number, createInfo: CreateUserRequest ): Promise<User> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = BASE_URL +  accountId + '/user';

  return await axios
    .post<User>(finalURL, createInfo ,{
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
